import { render, staticRenderFns } from "./PageCareer.vue?vue&type=template&id=00d56f08&"
import script from "./PageCareer.vue?vue&type=script&lang=js&"
export * from "./PageCareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports